import {Color, Title} from "common";

export class DatasetStyle {
    constructor(public title: Title, public color: Color) {
    }
}
